<template>
  <v-layout row justify-center>
    <v-dialog v-model="ExpensesGroupDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" flat class="mt-3 mb-3 body-2 primary">{{button}}</v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon dark @click="ExpensesGroupDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
            <span>Fechar</span>
          </v-tooltip>
          <v-toolbar-title>Cadastro de grupos de despesas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn dark flat @click="dialog = false">Salvar</v-btn> -->
          </v-toolbar-items>
        </v-toolbar>
        <h2
          class="title mx-4 mt-4 mb-1 text-xs-left"
          style="font-weight:400;"
        >Lista de grupos de despesas</h2>
        <div
          class="caption text-xs-left px-4"
        >Cadastre seus grupos de despesas fazendo vínculo com os grupos do sistema</div>
        <RegisterExpenses :reloadUserExpenseGroups="getUserExpenses" />
        <v-flex xs4 px-5 ml-1>
          <v-select
            class="iptSearchUserExpenses"
            v-model="condominium_id"
            :items="condominiums"
            append-icon="search"
            @click:append="getUserExpenses(condominium_id)"
            item-text="name_fantasy"
            item-value="id"
            label="Selecione o condomínio"
          ></v-select>
        </v-flex>
        <ExpenseList :userExpensesList="userExpensesGroup" :getUserExpenses="getUserExpenses" />
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import ExpenseList from "./ExpenseList";
import RegisterExpenses from "./RegisterExpenses";
export default {
  components: {
    ExpenseList,
    RegisterExpenses
  },
  props: {
    button: String
  },
  data() {
    return {
      condominiums: [],
      condominium_id: "",
      userExpensesGroup: [],
      ExpensesGroupDialog: false,
      notifications: false,
      sound: true,
      widgets: false
    };
  },
  mounted() {
    this.getComdominiums();
  },
  methods: {
    validSearch() {
      let fieldError = document.querySelector(".iptSearchUserExpenses label");
      fieldError.classList.add("primary--text");
      setTimeout(function() {
        fieldError.classList.remove("primary--text");
      }, 2000);
    },
    getComdominiums() {
      let obj = {
        url: "/api/condominium",
        query: "",
        method: "get"
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.condominiums = response.data;
      });
    },
    getUserExpenses() {
      let dataSearch = {};
      dataSearch.params = { condominium_id: this.condominium_id };

      if (!this.condominium_id) {
        this.validSearch();
        return;
      }

      let query = { condominium_id: this.condominium_id };

      let obj = {
        url: "/api/expenseGroup",
        query: dataSearch,
        method: "get"
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.userExpensesGroup = response.data.map(item => {
          item.condominium_id = this.condominium_id;
          return item;
        });
      });
    }
  }
};
</script>